// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FancyboxController from "./fancybox_controller.js"
application.register("fancybox", FancyboxController)

import GoogleMapsController from "./google_maps_controller.js"
application.register("google-maps", GoogleMapsController)
